// src/Services/UpgradeMemberService.ts
import { useApiHelper } from "../../utils/helper/apiHelper";

export const UpgradeMemberService = () => {
  const { post } = useApiHelper();

  // ✅ Check if a given PIN is valid
  const checkPin = async (pin: string) => {
    const obj = {
      procName: "UpgradebyPin",
      Para: JSON.stringify({
        PIN: pin,
        ActionMode: "CheckPin",
      }),
    };
    try {
      const res = await post(
        import.meta.env.VITE_APP_API_URL + "/ExecuteProcedure",
        obj
      );
      return res;
    } catch (err) {
      console.error("CheckPin API Error", err);
      return null;
    }
  };

  // ✅ Check if a given User is valid for upgrade (with a pin)
  const checkUser = async (payload: any) => {
    try {
      return await post(
        `${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`,
        payload
      );
    } catch (error) {
      console.error("Error fetching pin details:", error);
      throw error;
    }
  };

  // ✅ Upgrade user with PIN
  const upgradeUser = async (payload: {
    UserName: string;
    PaidBy: number;
    PIN: string;
  }) => {
    const obj = {
      procName: "UpgradebyPin",
      Para: JSON.stringify({
        UserName: payload.UserName,
        PaidBy: payload.PaidBy,
        PIN: payload.PIN,
        ActionMode: "UpgradeId",
      }),
    };
    try {
      const res = await post(
        import.meta.env.VITE_APP_API_URL + "/ExecuteProcedure",
        obj
      );
      return res;
    } catch (err) {
      console.error("UpgradeUser API Error", err);
      return null;
    }
  };

  // ✅ Get upgrade history of a member
  const getUpgradeDetails = async (memberId: number) => {
    const obj = {
      procName: "UpgradebyPin",
      Para: JSON.stringify({
        MemberId: memberId,
        ActionMode: "GetUpgradeDetails",
      }),
    };
    try {
      const res = await post(
        import.meta.env.VITE_APP_API_URL + "/ExecuteProcedure",
        obj
      );
      return res;
    } catch (err) {
      console.error("GetUpgradeDetails API Error", err);
      return null;
    }
  };

  return {
    checkPin,
    checkUser,
    upgradeUser,
    getUpgradeDetails,
  };
};
